<template>
  <div
    :style="paddingCalculator"
    :class="$store.getters['main/getBackgroundTone'](evenOdd)"
  >
    <div class="container">
      <div class="catalogue-head flex-box between">
        <div class="titles">
          <h3 class="catalogue-ttl tbc-medium  font-38">
            {{ _.get(contentData, `conf.header.title`) }}
          </h3>
          <h4 class="catalogue-teaser tbc-regular  font-18">
            {{ _.get(contentData, `conf.header.teaser`) }}
          </h4>
        </div>

        <div class="catalogue-head-right flex-box">
          <router-link
            v-if="_.get(contentData, `conf.header.full_list_url`)"
            :to="_.get(contentData, `conf.header.full_list_url`)"
            class="event-top-content-all flex-center tbc-bold font-16 text-user-select uppercase"
            >{{
              _.get(contentData, `conf.header.full_list_title`)
            }}</router-link
          >
        </div>
      </div>
      <div class="partners relative">
        <swiper
          ref="productsSlider"
          class="partners-slider grab default-swiper"
          :options="swiperOptions"
        >
          <swiper-slide
            class="partners__slide"
            v-for="(product, index) in _.get(contentData, 'data.list')"
            :key="index"
          >
            <a
              :target="_.get(product, 'link.url_target') == 1 ? '_blank' : ''"
              :href="_.get(product, 'link.url')"
              class="partners__img"
              v-html="_.get(product, 'logo')"
            >
            </a>
          </swiper-slide>
          <div class="swiper-scrollbar" slot="scrollbar">
            <div
              class="swiper-scrollbar-drag"
              style="width: 30%"
              slot="scrollbar"
            ></div>
          </div>
        </swiper>

        <div class="swiper-default-navigation flex-box desk container">
          <div class="catalogue-btn-prev" slot="button-prev">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                transform="translate(0 0)"
                fill="#575757"
              />
            </svg>
          </div>
          <div class="catalogue-btn-next" slot="button-next">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                transform="translate(0 0)"
                fill="#575757"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paddingCalculator from "@/mixins/paddingMixin";

export default {
  props: ["contentData", "evenOdd"],
  mixins: [paddingCalculator],

  data() {
    return {
      pTopDesktop: 89,
      pBottomDesktop: 89,

      swiperOptions: {
        spaceBetween: 30,
        slidesPerView: 4,
        speed: 800,
        watchOverflow: true,
        breakpoints: {
          320: {
            slidesPerView: 1.4,
            scrollbar: {
              dragSize: 129
            }
          },
          414: {
            slidesPerView: 2.1,
            scrollbar: {
              dragSize: 129
            }
          },
          // 415: {
          //   slidesPerView: 3
          // },
          768: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 4
          },
          1441: {
            slidesPerView: 4
          }
        },

        grabCursor: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
          dragSize: 300
        },

        navigation: {
          nextEl: ".catalogue-btn-next",
          prevEl: ".catalogue-btn-prev"
        },
        touchStartPreventDefault: false,

        on: {
          touchMove() {
            document
              .querySelectorAll(".partners-slider .swiper-slide")
              .forEach(slide => {
                slide.style.transform = "scale(0.90, 0.90)";
              });
          },
          touchEnd() {
            document
              .querySelectorAll(".partners-slider .swiper-slide")
              .forEach(slide => {
                slide.style.transform = "scale(1, 1)";
              });
          }
        }
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.partners {
  &__img {
    border-radius: 6px;
    width: 100%;
    height: 107px;
    border: 1px solid #364756;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    img {
      position: absolute;
      width: 80%;
      height: 80%;
      object-fit: contain;
      max-width: 190px;
      max-height: 150px;
    }
  }
  &__slide {
    width: 255px;
  }
  &__content {
    .title {
      margin-bottom: 15px;
      margin-top: 34px;
    }
    .teaser {
      line-height: 21px;
      color: #dadada;
      opacity: 0.9;
    }
  }
}
</style>
<style>
.partners >>> svg {
  max-width: 70%;
}
.partners-slider .swiper-slide {
  transition: 0.6s ease !important;
}
.catalogue-head {
  padding-bottom: 49px;
}

.catalogue-head .titles .catalogue-ttl {
  margin-bottom: 12px;
}
.catalogue-head .titles .catalogue-teaser {
  color: #dadadad5;
}

@media (max-width: 767px) {
  .catalogue-head {
    padding-bottom: 43px;
  }
  .catalogue-ttl.font-38 {
    font-size: 24px;
  }
  .catalogue-head .titles .catalogue-ttl {
    font-size: 24px;
  }
  .catalogue-head .titles .catalogue-teaser {
    font-size: 16px;
  }
}
</style>
